// extracted by mini-css-extract-plugin
export default {"CompanyPlanNewWallet":"XY08EsKbs70F5sez55DR","isDisabled":"tG7IbUgB3FrS94DNhTPQ"};